import { ComponentClass, createElement, FunctionComponent } from "react";
import { AccessDeniedStrategy, AuthorizationChecker } from "@tecorien/mimic-v2";
import classNames from "classnames";
import { genericMemo } from "../../../../utils";

import styles from "./style.module.scss";

export type SplitOptionButtonProps<P> = {
  requiredPermissions?: string | string[]
  requiredOneOfPermissions?: string | string[]
  strategy?: AccessDeniedStrategy,
  component?: string | FunctionComponent<P> | ComponentClass<P>,
  className?: string,
} & P


export const SplitOptionButton = genericMemo(<P extends object>(
  {
    requiredPermissions,
    requiredOneOfPermissions,
    strategy,
    className,
    component = "button",
    ...props
  }: SplitOptionButtonProps<P>) => {
  return (
    <AuthorizationChecker
      requiredPermissions={requiredPermissions}
      requiredOneOfPermissions={requiredOneOfPermissions}
      strategy={strategy}
    >
      {
        createElement(component as any, {
          ...props,
          className: classNames(className, styles.optionButton),
        })
      }
    </AuthorizationChecker>
  );
});


export default SplitOptionButton;
